import React, { Component } from 'react'
// import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { Scheduler as KendoScheduler } from '@progress/kendo-scheduler-react-wrapper'
// import {
//   listScheduledEmails,
//   cancelScheduledEmail,
// } from '../../actions/scheduledEmails'
// import { listTemplates } from '../../actions/template'

const mapStateToProps = state => ({
  tasksByID: state.tasks.tasksByID,
})

// const mapDispatchToProps = dispatch =>
//   bindActionCreators(
//     {
//       listScheduledEmails,
//       cancelScheduledEmail,
//       listTemplates,
//     },
//     dispatch
//   )

const styles = theme => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  button: {
    margin: theme.spacing.unit,
  },
  floatingActionButton: {
    position: 'fixed',
    bottom: '23px',
    right: '23px',
    color: '#fff',
  },
  progress: {
    margin: theme.spacing.unit * 2,
  },
  root: {
    flexGrow: 1,
    border: 'solid 1px #adadad',
    borderRadius: 35,
  },
  gridItem: {
    padding: theme.spacing.unit * 2,
    color: theme.palette.text.secondary,
  },
})

class Scheduler extends Component {
  constructor(props) {
    super(props)

    this.state = {
      expanded: null,
      open: false,
      selectedDate: null,
    }
  }

  handleEventClick = e => {
    e.preventDefault()
    if (e.event.id === 0) {
      this.props.history.push(`/tasks/new?date=${e.event.start.toISOString()}`)
    } else {
      this.props.history.push(`/tasks/${e.event.id}`)
    }
  }

  render() {
    const { classes, tasksByID, ownedBy } = this.props

    const taskObj = {
      '1': { name: 'send_email', when: 'when_to_send' },
      '2': { name: 'send_sms', when: 'when_to_send' },
      '4': { name: 'add_contacts_to_group', when: 'when_to_trigger' },
      '5': { name: 'remove_contacts_from_group', when: 'when_to_trigger' },
      '6': { name: 'move_contacts_btwn_groups', when: 'when_to_trigger' },
    }

    const eventData = Object.values(tasksByID)
      .filter(task => {
        if (ownedBy) {
          return (
            task[taskObj[task.task_type_id].name][
              taskObj[task.task_type_id].when
            ] &&
            task.owned_by &&
            task.owned_by.id === ownedBy.id &&
            task.owned_by.type === ownedBy.type
          )
        }
        return true
      })
      .map(task => {
        const whenToSendDate =
          task[taskObj[task.task_type_id].name][taskObj[task.task_type_id].when]

        return {
          id: task.id,
          start: whenToSendDate,
          end: whenToSendDate,
          title: task.description,
        }
      })

    return (
      <div className={classes.root}>
        <KendoScheduler
          height={600}
          dataSource={eventData}
          edit={e => this.handleEventClick(e)}
          views={[
            'month',
            { type: 'week', showWorkHours: true },
            { type: 'day', showWorkHours: true },
          ]}
        />
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  // mapDispatchToProps
  null,
)(withStyles(styles)(Scheduler))
